var _defs, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "TikTok",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradRed",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF0050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4D6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradBlue",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C3B8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradBlue)",
    d: "M164.9 89.4c11.6 8.5 25.9 13.6 41.4 13.6v-28.4c-3.2.3-6.5.1-9.6-.4v22.5c-15.5 0-29.8-5.1-41.4-13.6v55.4c0 28.2-22.9 51.1-51.1 51.1-10.5 0-20.2-3.2-28.3-8.7 9.3 9.5 22.2 15.4 36.5 15.4 28.2 0 51.1-22.9 51.1-51.1V89.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradRed)",
    d: "M196.7 74.2c-10.6-5.8-19.3-14.8-24.7-25.8-5-3.6-9.3-8.2-12.6-13.4 3 12.2 10.5 22.6 20.5 29.2 5.8 3.8 12.4 6.4 19.6 7.4v-6c-1 .1-2 .2-2.9.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.6 84.1c11.6 8.5 25.9 13.6 41.4 13.6v-22.5c-7.2-1-13.8-3.6-19.6-7.4-10-6.6-17.5-17-20.5-29.2-2.2-3.3-3.9-7-5-10.9h-27.1v124.2c-.2 14.6-12.2 26.4-26.9 26.4-8.7 0-16.4-4.1-21.4-10.4-4.2-5.3-6.7-12-6.7-19.2 0-17.4 14.1-31.5 31.5-31.5 3.2 0 6.3.5 9.2 1.4v-29.1c-3-.4-6.1-.7-9.2-.7-33.5 0-60.6 27.1-60.6 60.6 0 16.3 6.4 31.1 16.8 42.1 11 11.6 26.5 18.8 43.7 18.8 33.7 0 61.1-27.3 61.1-61.1V84.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.eb43096d06b78ab4f3135e249d1069f5.svg";
export { ForwardRef as ReactComponent };